import type { Icon } from '../../../src/lib/types'
export const mdiFormatHorizontalAlignCenter: Icon = {
  "id": "format-horizontal-align-center",
  "name": "Format Horizontal Align Center",
  "path": "M19,16V13H23V11H19V8L15,12L19,16M5,8V11H1V13H5V16L9,12L5,8M11,20H13V4H11V20Z",
  "as": [
    "format-horizontal-align-centre",
    "arrow-horizontal-collapse"
  ],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatHorizontalAlignCenter